import { render, staticRenderFns } from "./ReuploadPhotoPage.vue?vue&type=template&id=058739b3&scoped=true"
import script from "./ReuploadPhotoPage.vue?vue&type=script&lang=js"
export * from "./ReuploadPhotoPage.vue?vue&type=script&lang=js"
import style0 from "./ReuploadPhotoPage.vue?vue&type=style&index=0&id=058739b3&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "058739b3",
  null
  
)

export default component.exports